<div mat-dialog-title class="mat-dialog-title">
  <div><strong>Ticket</strong>
    <i class="fa fa-times-circle pull-right" (click)="dialogRef.close();" aria-hidden="true"></i>
  </div>
</div>
<div mat-dialog-content class="container-fluid overflow-hidden">
  <div class="row">
    <div class="col-md-6 align-content-md-start issuedetailPadding">
      <label for="issueDetail" class="issuedetaillabel">Issue Detail :</label>
      <textarea id="issueDetail" class="taxonomy-textarea-template" rows="1" [(ngModel)]="helpdesk_Detail_desc">
      </textarea>
    </div>
    <div class="col-md-6 align-content-md-start issuedetailPadding">
      <EIPMultiSelectAutoComplete [dataSource]="imageObject" setId="" TextField="title" ValueField="title"
        isEmitOnSelect="Y" WaterMarkText="File name" ShowTextValueField='N' [clearValue]='matCatClear'
        [IsCascading]='true' [defaultSelectedValues]="selectedimages">
      </EIPMultiSelectAutoComplete>
    </div>
  </div>
  <div class="row justify-content-center flex-row align-items-center">
    <div class="col-md-1 col-sm-1 col-lg-1 col-xl-1">
      <i class="font20 fa fa-angle-left eip-pxy-10" title="Previous Image" (click)="prevImageClick()" id=""></i>
    </div>
    <div class="col-md-10 col-sm-10 col-xl-10 col-lg-10 text-center">
      <ng-image-slider *ngIf="imageObject.length > 0 else NoScreenshots" #nav [images]="imageObject" [infinite]="false"
        [autoSlide]="5" [imageSize]="{width: 541, height: 300,space: 4}" slideImage="1" showArrow="true">
      </ng-image-slider>
      <ng-template #NoScreenshots>
        <span>No Screenshots available</span>
      </ng-template>
    </div>
    <div class="col-md-1 col-sm-1 col-lg-1 col-xl-1">
      <i class="font20 fa fa-angle-right eip-pxy-10" title="Next Image" (click)="nextImageClick()" id=""></i>
    </div>
  </div>


  <br />
</div>
<div mat-dialog-actions>
  <button type="submit" class="btn btn-primary float-right eip-mxy-20" (click)="HelpdeskSend()" id="">
    Create Ticket
  </button>
</div>